document.addEventListener("DOMContentLoaded", function () {
  let currentIndex = 0;
  const items = document.querySelectorAll(".shop-items li");
  const slider = document.querySelector(".shop-items");
  const isTwoPerRow = slider.classList.contains("two-per-row");
  const itemsPerPage = isTwoPerRow ? 2 : 1;
  const totalItems = items.length;

  function getItems() {
    return [...document.querySelectorAll(".shop-items li")];
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function updateSlider() {
    const itemWidth = items[0].offsetWidth + parseInt(getComputedStyle(items[0]).marginRight);
    const scrollTo = itemWidth * currentIndex;
    slider.scrollLeft = scrollTo;

    items.forEach((li) => li.classList.remove("active"));
    for (let i = 0; i < itemsPerPage; i++) {
      if (items[currentIndex + i]) {
        items[currentIndex + i].classList.add("active");
      }
    }

    const prevBtn = document.getElementById("prev");
    const nextBtn = document.getElementById("next");

    if (prevBtn) {
      prevBtn.disabled = currentIndex === 0;
    }
    if (nextBtn) {
      nextBtn.disabled = currentIndex + itemsPerPage === totalItems;
    }
  }

  const nextBtn = document.getElementById("next");
  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      if (currentIndex + itemsPerPage < totalItems) {
        currentIndex++;
        updateSlider();
      }
    });
  }

  const prevBtn = document.getElementById("prev");
  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });
  }

  document.addEventListener("click", (e) => {
    const hotspot = e.target.closest(".hotspot");
    if (!hotspot) return;

    e.preventDefault();
    e.stopPropagation();

    const items = getItems();
    const index = parseInt(hotspot.dataset.index, 10);
    const item = items[index];

    document.querySelectorAll(".hotspot-info").forEach(el => el.style.display = "none");
    const infoBlock = document.querySelector(hotspot.dataset.info);
    if (infoBlock) infoBlock.style.display = "block";

    if (isMobile()) {
      const modal = document.getElementById("myModal");
      modal.classList.add("active");
      modal.style.display = "block";
      document.body.classList.add("modal-open");
    } else {
      //slider.scrollLeft = item.offsetLeft;
      const slider = document.querySelector(".shop-items");
      slider.scrollTo({
        left: item.offsetLeft,
        behavior: "smooth"
      });
      items.forEach(li => li.classList.remove("active"));
      item.classList.add("active");
      currentIndex = index;
    }
  });

  document.addEventListener("click", (e) => {
    const li = e.target.closest(".shop-items li");
    if (!li) return;

    e.stopPropagation();

    getItems().forEach(el => el.classList.remove("active"));
    li.classList.add("active");

    document.querySelectorAll(".hotspot-info").forEach(el => el.style.display = "none");
    const infoBlock = document.querySelector(li.dataset.info);
    if (infoBlock) infoBlock.style.display = "block";
  });

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("#openModal");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    const modal = document.getElementById("myModal");
    if (!modal) return;

    // Portal modal to <body> to escape any transformed ancestor that would
    // break position: fixed (containing-block promotion).
    // Also add the section scope class so existing CSS rules
    // (.section-shop-the-look .items-product etc.) continue to match.
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
      modal.classList.add('section-shop-the-look');
    }

    // Lock background scroll (preserve scroll position)
    window.__myModalScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.__myModalScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.classList.add("modal-open");

    modal.classList.add("active");
    modal.style.display = "block";
  });

  function closeMyModal() {
    const modal = document.getElementById("myModal");
    if (!modal) return;
    modal.classList.remove("active");

    // Capture saved scroll position before clearing lock styles
    const scrollY = window.__myModalScrollY;

    // Unlock background scroll
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    // Restore scroll position instantly (not smoothly) to prevent visible jump.
    // The theme sets `html { scroll-behavior: smooth }` globally, so a normal
    // scrollTo would animate from 0 to scrollY after the body unlocks.
    if (typeof scrollY === 'number') {
      window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
      window.__myModalScrollY = null;
    }

    setTimeout(() => {
      document.body.classList.remove("modal-open");
      modal.style.display = "none";
    }, 220);
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest(".close")) closeMyModal();
  });

  window.addEventListener("click", (e) => {
    const modal = document.getElementById("myModal");
    if (e.target === modal) closeMyModal();
  });

  document.addEventListener("keydown", (e) => {
    if ((e.key === 'Escape' || e.code === 'Escape') && document.body.classList.contains('modal-open')) {
      closeMyModal();
    }
  });

  updateSlider();
});
